<template>
  <div class="resource-page">
    <section class="hero">
      <img
        class="hero-bg"
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/resource_banner.png"
        alt=""
      />
      <div class="hero-inner">
        <div class="title">资源下载</div>
        <!-- <div class="desc">高频问题一键直达，告别繁琐咨询等待</div> -->
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="resource-grid">
          <div
            class="resource-card"
            v-for="item in resources"
            :key="item.title"
          >
            <div
              class="resource-preview"
              :class="{ 'is-clickable': item.pdfUrl }"
              @click="openPreview(item)"
            >
              <img
                :src="item.image"
                :alt="item.title"
                width="375"
                height="260"
              />
              <div v-if="item.pdfUrl" class="preview-hint">
                <i class="el-icon-view"></i>
                点击预览
              </div>
            </div>
            <div class="resource-meta">
              <h3>{{ item.title }}</h3>
              <button
                v-if="item.pdfUrl"
                type="button"
                class="download-link"
                :disabled="downloading === item.title"
                @click="downloadFile(item)"
              >
                <i
                  :class="
                    downloading === item.title
                      ? 'el-icon-loading'
                      : 'el-icon-download'
                  "
                ></i>
                <span style="color: #333333; font-size: 14px">{{
                  downloading === item.title ? "下载中..." : "下载"
                }}</span>
              </button>
              <span v-else class="download-link is-disabled" title="文件准备中">
                <i class="el-icon-download"></i>
                <span style="color: #333333; font-size: 14px">下载</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { setPageSeo } from "../../util/seo.js";

const RESOURCE_SEO = {
  title: "资源下载 | 智慧服务 - 焱图慧云",
  description:
    "焱图慧云资源下载中心，提供企业画册完整版与简版下载，了解公司产品与解决方案。",
  canonicalPath: "/resource-download",
};

const DOCS_BASE =
  "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/docs";

export default {
  name: "ResourceDownload",
  data() {
    return {
      downloading: "",
      resources: [
        {
          title: "企业画册2026",
          fileName: "焱图宣传册-中文版.pdf",
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/resource_document_icon1.png",
          pdfUrl: `${DOCS_BASE}/${encodeURIComponent(
            "焱图宣传册-中文版_compressed.pdf",
          )}`,
        },
        {
          title: "企业画册简版2026",
          fileName: "企业画册简版-四折页.pdf",
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/resource_document_icon2.png",
          pdfUrl: `${DOCS_BASE}/${encodeURIComponent("四折页.pdf")}`,
        },
      ],
    };
  },
  mounted() {
    setPageSeo(RESOURCE_SEO);
  },
  methods: {
    openPreview(item) {
      if (!item || !item.pdfUrl) return;
      window.open(item.pdfUrl, "_blank", "noopener,noreferrer");
    },
    async downloadFile(item) {
      if (!item || !item.pdfUrl || this.downloading) return;

      this.downloading = item.title;
      const fileName = item.fileName || `${item.title}.pdf`;

      try {
        const response = await fetch(item.pdfUrl, { mode: "cors" });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = fileName;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
      } catch (error) {
        // 跨域受限时回退为新窗口打开，由浏览器处理下载/另存
        const link = document.createElement("a");
        link.href = item.pdfUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } finally {
        this.downloading = "";
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.resource-page {
  --blue: #2372E9;
  --navy: #203149;
  --text: #26364b;
  --line: #e6ebf3;
  color: var(--text);
  background: #fff;

  .container {
    max-width: var(--main-width);
    width: 84%;
    margin: 0 auto;
  }

  .hero {
    position: relative;
    margin-top: 80px;
    line-height: 0;
  }

  .hero-bg {
    display: block;
    width: 100%;
    height: auto;
  }

  .hero-inner {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 84%;
    max-width: var(--main-width);
    padding: 0;
    text-align: center;
    color: #fff;
    line-height: normal;
    transform: translate(-50%, -50%);

    .title {
      margin: 0 0 1.44rem;
      font-size: 3rem;
      letter-spacing: 2px;
      font-weight: bold;
      line-height: 1.2;
    }

    .desc {
      letter-spacing: 2px;
      font-size: 1.25rem;
      line-height: 2.2rem;
    }
  }

  .section {
    padding: 72px 0 96px;
    background: #f5f7fa;
  }

  .resource-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: flex-start;
  }

  .resource-card {
    display: flex;
    flex-direction: column;
    width: 375px;
    max-width: 100%;
    overflow: hidden;
    background: #fff;
  }

  .resource-preview {
    position: relative;
    width: 100%;
    aspect-ratio: 375 / 260;
    line-height: 0;
    background: #e8ebf0;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }

    &.is-clickable {
      cursor: pointer;

      &:hover .preview-hint {
        opacity: 1;
      }
    }
  }

  .preview-hint {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: rgba(32, 49, 73, 0.55);
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;

    i {
      font-size: 20px;
    }
  }

  .resource-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 18px 20px 22px;
    background: #fff;

    h3 {
      margin: 0;
      color: var(--navy);
      font-size: 18px;
      font-weight: 700;
      line-height: 1.4;
    }
  }

  .download-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--blue);
    font-size: 16px;
    font-weight: 600;
    font-family: inherit;
    text-decoration: none;
    cursor: pointer;

    i {
      font-size: 18px;
    }

    &:hover:not(:disabled) {
      opacity: 0.85;
    }

    &:disabled {
      opacity: 0.6;
      cursor: wait;
    }

    &.is-disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
}

@media (max-width: 900px) {
  .resource-page {
    .hero {
      margin-top: 128px;
    }

    .hero-inner {
      .title {
        font-size: 24px;
        margin-bottom: 10px;
      }

      .desc {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 1px;
      }
    }

    .section {
      padding: 40px 0 64px;
    }

    .resource-grid {
      gap: 16px;
    }

    .resource-card {
      width: 100%;
      max-width: 375px;
    }

    .resource-meta {
      padding: 16px 16px 18px;

      h3 {
        font-size: 16px;
      }
    }

    .preview-hint {
      opacity: 1;
      background: rgba(32, 49, 73, 0.35);
      font-size: 14px;
    }
  }
}
</style>
